import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import styles from '../styles.styl';

function VideoView({ publisher }) {
  const deviceVideoRef = useRef();

  useEffect(() => {
    const deviceVideoEl = deviceVideoRef.current;
    if (publisher && publisher.video && deviceVideoEl) {
      deviceVideoEl.srcObject = publisher.video.srcObject;
    }
  }, [publisher]);

  return (
    <div className={styles.video}>
      <video ref={deviceVideoRef} autoPlay muted playsInline />
    </div>
  );
}

VideoView.propTypes = {
  publisher: PropTypes.object.isRequired,
};

export default VideoView;



// WEBPACK FOOTER //
// ./src/components/VirtualVideoRoom/Components/MediaSettings/VideoSettings/VideoView.jsx